import { GuestType } from '../../components/Objects/Filter/GuestsSelector/GuestsSelector';
import { ObjectsParams } from '../../types/ParamsTypes';
import { StepperOperator } from '../../components/common/Stepper/Stepper';

export const getUpdatedObjectFilterGuestsParams = (
  objectsParams: ObjectsParams,
  guestType: GuestType,
  value: number,
  operator: StepperOperator,
): ObjectsParams => {
  let updatedValue = value;
  let updatedObjectFilterParams = objectsParams;

  if (operator === StepperOperator.INCREMENT) {
    updatedValue = updatedValue + 1;
  }

  if (operator === StepperOperator.DECREMENT && updatedValue > 0) {
    updatedValue = updatedValue - 1;
  }

  if (guestType === GuestType.ADULTS) {
    updatedObjectFilterParams = { ...updatedObjectFilterParams, numberOfAdults: updatedValue };

    return updatedObjectFilterParams;
  }

  if (guestType === GuestType.CHILDREN) {
    const updatedChildrenAge = [...updatedObjectFilterParams.agesOfChildren];

    if (operator === StepperOperator.INCREMENT) {
      updatedChildrenAge?.push(0);
    }

    if (operator === StepperOperator.DECREMENT) {
      updatedChildrenAge?.pop();
    }
    return {
      ...updatedObjectFilterParams,
      numberOfChildren: updatedValue,
      agesOfChildren: updatedChildrenAge,
    };
  }

  if (guestType === GuestType.PETS) {
    updatedObjectFilterParams = { ...updatedObjectFilterParams, numberOfPets: updatedValue };

    return updatedObjectFilterParams;
  }

  return updatedObjectFilterParams;
};

export const getUpdatedObjectFilterChildrenAgeParams = (
  objectsParams: ObjectsParams,
  age: number,
  idx: number,
): ObjectsParams => {
  const updatedObjectFilterParams = objectsParams;
  updatedObjectFilterParams.agesOfChildren[idx] = age;

  return updatedObjectFilterParams;
};
